import React, { ReactElement } from 'react';
import { twJoin } from 'tailwind-merge';

type FullWidthConstrainedLayoutProps = {
  children: ReactElement[] | ReactElement;
  fullWidth?: boolean;
};

export function FullWidthConstrainedLayout({
  children,
  fullWidth = false,
}: FullWidthConstrainedLayoutProps): ReactElement {
  return (
    <main
      className={twJoin(
        'flex grow flex-col',
        fullWidth ? 'w-full' : 'container mx-auto',
      )}
    >
      {children}
    </main>
  );
}
